// Video
document.addEventListener("DOMContentLoaded", () => {
  const deferredVideos = document.querySelectorAll("deferred-media[autoplay]");

  if (!("IntersectionObserver" in window)) return;

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const media = entry.target;

      if (media.showDeferredMedia) {
        media.showDeferredMedia();
      } else {
        const template = media.querySelector("template");

        if (template) {
          media.appendChild(template.content.cloneNode(true));
          template.remove();
        }
      }

      const video = media.querySelector("video");

      if (video) {
        video.play().catch(() => {});
      }

      obs.unobserve(media);
    });
  }, {
    rootMargin: "150px"
  });

  deferredVideos.forEach(video => observer.observe(video));
});